export const OFFLINEAPP = {
    DTCODE: "filter_dt_code",
    DTSITECODE: "filter_dt_site_code",
    OUTLETCODE: "filter_outlet_code",
    NetworkError: "Network Error"
};

export const excelDataRegex = /(^[^a-zA-Z0-9])|([^a-zA-Z0-9]$)/;
export const MAX_SEARCH_TERMS = 10;